import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, ToastController } from '@ionic/angular';
import { OrderService } from 'src/app/services/order.service';

@Component({
  selector: 'app-reorder-request',
  templateUrl: './reorder-request.page.html',
  styleUrls: ['./reorder-request.page.scss'],
})
export class ReorderRequestPage implements OnInit {

  @Input() orderNumber: string;
  @Input() orderType: string;
  is_dark_mode = false;
  form = {
    left_lens: true,
    right_lens: true,
    message:'',
    nr:'',
    type:''
  }
  formb = {
    left_glas: true,
    right_glas: true,
    frame: true,
    message:'',
    nr:'',
    type:''
  }
  error_msg:string = '';

  constructor(
    private modalCtrl: ModalController,
    private orderService: OrderService,
    public toastController: ToastController,
    private router:Router
  ) {}

   ionViewWillEnter(){
    let isDark = localStorage.getItem('dark_mode');
    if(isDark == 'true'){
      this.is_dark_mode = true;
    }else{
      this.is_dark_mode = false;
    }
   }

  ngOnInit() {
  }

  sendLensesReorderRequest(){
    if(this.form.left_lens === false && this.form.right_lens === false){
      this.error_msg = 'Please select Linke Linse OR Rechte Linse.';
    }else{
      this.error_msg = '';
      if(this.orderNumber && this.orderType){
        this.form.nr = this.orderNumber;
        this.form.type = this.orderType;
        this.orderService.reOrderLensesRequest(this.form).subscribe( 
          response => {          
            this.presentToast(response.message);    
            this.close();       
        },
        error => {
          this.presentToast(error.error.message);        
        })
      }
    }
  }

  sendGlassesReorderRequest(){
    if(this.formb.left_glas === false && this.formb.right_glas === false && this.formb.frame === false){
      this.error_msg = 'Please select Linkes Glas OR Rechtes Glas OR Fassung.';
    }else{
      this.error_msg = '';
      if(this.orderNumber && this.orderType){
        this.formb.nr = this.orderNumber;
        this.formb.type = this.orderType;
        this.orderService.reOrderGlassRequest(this.formb).subscribe( 
          response => {          
            this.presentToast(response.message);    
            this.close();       
        },
        error => {
          this.presentToast(error.error.message);        
        })
      }
    }
  }

  async presentToast(error_msg) {
    const toast = await this.toastController.create({
      message: error_msg,
      duration: 2000
    });
    toast.present();
  }

  async close() {
    await this.modalCtrl.dismiss();
  }

  backHome(){
    this.router.navigate(['home']);
  }

}
